/**
 * @description 测距组件，需引入地图插件
 * [AMap.RangingTool,AMap.Walking,AMap.Driving,AMap.Riding]
 */
import { FC, ForwardedRef, forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from 'react';
import IconFont from '@/common/components/IconFont';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import styles from './index.module.less';
import cs from 'classnames';
import { rulers, RulerType } from '../ts-config';
import { getLngLatAddress } from '@/common/utils/map';
import { useMethods } from '@lhb/hook';
import { isNotEmptyAny } from '@lhb/func';
import { useBigdataFn } from '@/common/utils/bigdata';
import { mapZIndex } from '@/views/youth/pages/map/components/MapCon/CityView/ts-config';
// // import { bigdataBtn } from '@/common/utils/bigdata';

interface RulerInfoType {
  startAddress?: string;
  endAddress?: string;
  mode?: string;
  time?: number;
  distance?: number;
}

interface Props {
  _mapIns?: any;
  style?: any;
  className?: string;
  clearClickEvent: Function;
  addClickEvent: Function;
  rulering:boolean;
  setRulering:Function;
  rulerType: number; // 测距类型
  setRulerType: Function; // 设置测距类型 用于测距开始和测距结束的时候重置
  setSelected: Function; // 设置工具箱的选中效果
  setIsShowBox: Function; // 设置是否显示工具箱
  setIsShowPanel: Function;
  setIsShowInputPanel: Function; // 切换输入弹框显隐
  isShowInputPanel: boolean; // 输入弹框是否展示中（用于门控 RangingTool 的 turnOn）
  finallyShowStatus?:Function;
  setTargetOperation?: Function;
  targetOperation?: string;
  // isCheckInsideMapOperate?:boolean;
  isCheckOutsideMapOperate?:boolean;
  setIsCheckInsideMapOperate?:Function;
  setIsCheckOutsideMapOperate?:Function;
  rulerEventId?: string;
  trigger?: string;
  floatDirection?: string;
  isAutoFitView?: boolean; // 用于控制在路径规划结束后，是否自动调整地图视野使绘制的路线处于视口的可见范围
  ref?: ForwardedRef<any>
}

const Ruler: FC<Props> = forwardRef(({
  _mapIns, // 地图实例
  style,
  className,
  clearClickEvent,
  addClickEvent,
  rulering, // 测距中
  setRulering,
  rulerType, // 测距类型
  setRulerType,
  setSelected,
  setIsShowBox,
  setIsShowPanel,
  setIsShowInputPanel,
  isShowInputPanel,
  finallyShowStatus,
  targetOperation,
  setTargetOperation,
  // isCheckInsideMapOperate,
  isCheckOutsideMapOperate,
  setIsCheckInsideMapOperate,
  setIsCheckOutsideMapOperate,
  rulerEventId,
  trigger = 'click',
  floatDirection = 'right',
  isAutoFitView = true, // 兼容历史逻辑，所以默认值为true
}, ref) => {
  const zIndex = Object.values(mapZIndex).reduce((a, b) => Math.max(a, b), -Infinity);
  const bigdataFn = useBigdataFn(true); // 使用埋点 Hook
  const bigdataFnRef: any = useRef(bigdataFn);
  const nodePositionsRef:any = useRef([]);
  const totalDistanceRef:any = useRef(0);
  const tipMarkerREf:any = useRef(null);
  const dragPixelRef = useRef<any>(null); // marker 拖拽时pixel的缓存

  const [status, setStatus] = useState<boolean>(false);
  const [rulerIns, setRulerIns] = useState<any>(null);

  const [totalDistance, setTotalDistance] = useState<any>(0); // 记录所有节点间的总距离
  const [rulerMarkers, setRulerInfoMarkers] = useState<any>([]);
  // 「输入」模式产生的所有覆盖物，每条 entry = { overlays: any[], instance?: any }
  // 关闭弹框时遍历清除；closeIcon 单删时同步 splice 该 entry
  const inputModeMarkersRef = useRef<any[]>([]);

  useEffect(() => {

    return () => {
      clear();
    };
  }, []);

  useEffect(() => {
    bigdataFnRef.current = bigdataFn;
  }, [bigdataFn]);

  useEffect(() => {
    if (!_mapIns) return;

    if (!window?.AMap?.RangingTool) {
      throw new Error('AMap.RangingTool 未引入！');
    }
    const offset = new window.AMap.Pixel(-7, -7);
    // 测距实例配置
    const startMarkerOptions = {
      icon: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_ruler_qidian.png`,
      offset,
      zIndex
    };
    const midMarkerOptions = {
      icon: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_ruler_zhongjian.png`,
      offset,
      zIndex
    };
    const endMarkerOptions = {
      icon: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_ruler_zhongdian.png`,
      offset,
      zIndex
    };
    const lineOptions: any = {
      strokeColor: '#F23030',
      strokeOpacity: 1,
      zIndex
    };
    const tmpLineOptions: any = {
      strokeColor: 'F3B8B8',
      strokeOpacity: 1,
      zIndex
    };
    const rulerOptions = {
      lineOptions,
      tmpLineOptions,
      startMarkerOptions,
      midMarkerOptions,
      endMarkerOptions,
      startLabelText: '起点',
      endLabelText: '直线距离{d}公里</div>',

    };
    if (trigger === 'hover') {
      lineOptions.zIndex = zIndex;
      tmpLineOptions.zIndex = zIndex;
    }
    const ruler = new window.AMap.RangingTool(_mapIns, rulerOptions);
    setRulerIns(ruler);
  }, [_mapIns]);

  useEffect(() => {
    if (!_mapIns) return;

    const tipMarker = new window.AMap.Marker({
      map: _mapIns,
      anchor: 'top-left',
      zIndex: zIndex,
      content: ' ',
      offset: new window.AMap.Pixel(6, 6),
    });
    if (trigger === 'hover') {
      tipMarker.zIndex = zIndex;
    }
    tipMarkerREf.current = tipMarker;
    _mapIns.add(tipMarkerREf.current);


    if (rulering && rulerType === RulerType.Line) {
      _mapIns.on('mousemove', methods.handleMouseMove);
    }

    return () => {
      _mapIns.off('mousemove', methods.handleMouseMove);
      tipMarkerREf.current && _mapIns?.remove?.(tipMarkerREf.current);
      tipMarkerREf.current = null;
    };

  }, [_mapIns, rulering, nodePositionsRef, totalDistance, totalDistanceRef]);

  // 测距类型发生变化的时候
  useEffect(() => {
    if (!rulerIns) return;
    // 「输入」模式弹框打开期间：强制关闭 RangingTool 的地图点击监听，
    // 且 rulerType 变化不再触发 turnOn（输入模式的测距通过 handleInputMeasure 完成）
    if (isShowInputPanel) {
      rulerIns.turnOff();
      return;
    }

    if (rulerType) {
      setSelected((state) => (state === 0 ? 0 : state - 1)); // 清除工具箱按钮高亮
      clearClickEvent && clearClickEvent(); // 清除地图点击事件
      rulerIns?.turnOn(); // 开启距离量测功能
      setTargetOperation && setTargetOperation('ruler'); // 记录当前操作类型

      rulerIns.on('addnode', methods.handleAddNode);
      rulerIns.on('end', methods.handleEnd);
      if (rulerType === RulerType.Line) { // 直线测距时
        // 高德的RangingTool工具类，在确定了起点后(只有一个起点时)，当点击右键时会自动清空地图测距的覆盖物，所以这里需要处理相关的数据恢复初始值
        _mapIns.on('rightclick', methods.handleSpecialRightClick);
      }
    }

    // 在 useEffect 返回函数中清除事件监听器
    return () => {
      rulerIns.off('addnode', methods.handleAddNode);
      rulerIns.off('end', methods.handleEnd);
      _mapIns?.off?.('rightclick', methods.handleSpecialRightClick);
    };
  }, [rulerType, rulerMarkers, isShowInputPanel]);

  // 监听end事件
  useEffect(() => {
    if (!rulerIns) return;

    if (!rulerType) {
      setStatus(false);
      setRulering(false);
      addClickEvent && addClickEvent(); // 恢复地图点击事件
      rulerIns.turnOff(); // 关闭在地图上的测距状态
      setSelected((state) => state - 1); // 设置工具箱状态
      return;
    }
  }, [status, rulerType]);
  useEffect(() => {
    if (isCheckOutsideMapOperate) {
      setStatus(false);
      setSelected((state) => (state === 0 ? 0 : state - 1)); // 清除工具箱按钮高亮
      addClickEvent && addClickEvent(); // 添加地图点击事件
      setRulerType(0); // 重置测距类型
      rulerIns?.turnOff(); // 关闭距离量测功能
      setIsShowPanel(false);
      // 输入模式被外部取消时同步关弹框 + 清覆盖物
      setIsShowInputPanel(false);
      methods.clearInputModeMarkers();
    }
  }, [isCheckOutsideMapOperate]);
  useEffect(() => {
    if (!targetOperation) {
      setStatus(false);
      return;
    }
    if (targetOperation && targetOperation === 'dotMark') {
      rulerIns.turnOff(); // 关闭在地图上的测距状态
    }
  }, [targetOperation]);

  const {
    onClickRuler,
    calculateDistance,
    drawEndMarker,
    clear,
    ...methods
  } = useMethods({
    clear() {
      // setIsCheckOutsideMapOperate?.(true);
      setIsCheckInsideMapOperate?.(false);
      setStatus(false);
      setSelected((state) => (state === 0 ? 0 : state - 1)); // 清除工具箱按钮高亮
      addClickEvent && addClickEvent(); // 添加地图点击事件
      setTargetOperation && setTargetOperation(''); // 清除当前操作类型
      setRulerType(0); // 重置测距类型
      rulerIns?.turnOff(); // 关闭距离量测功能
      _mapIns?.off?.('mousemove', methods.handleMouseMove);
      tipMarkerREf.current && _mapIns?.remove?.(tipMarkerREf.current);
      tipMarkerREf.current = null;
      rulerIns?.off?.('addnode', methods.handleAddNode);
      rulerIns?.off?.('end', methods.handleEnd);
      setIsShowPanel(false);
      // 输入模式：关闭弹框 + 清覆盖物（统一兜底）
      setIsShowInputPanel(false);
      methods.clearInputModeMarkers();
    },
    /**
     * @description 点击工具箱中ruler工具
     * @param type 测距类型
     */
    onClickRuler: (type: number) => {
      setIsShowBox(false); // 关闭工具箱
      // 「输入」模式（type=5）走独立分支：不开 RangingTool、不设 rulerType、改开输入弹框
      if (type === RulerType.Input) {
        // 若当前在地图点击测距中，先 clear() 重置
        if (status) {
          clear();
        }
        setIsCheckOutsideMapOperate?.(false);
        setIsCheckInsideMapOperate?.(true);
        setStatus(true);
        setSelected((state) => state + 1); // 高亮工具箱按钮
        setIsShowPanel(false); // 关闭快捷面板（与输入弹框互斥）
        setIsShowInputPanel(true); // 打开输入弹框
        setTargetOperation && setTargetOperation('ruler');
        return;
      }
      if (status) {
        clear();
      } else {
        setIsCheckOutsideMapOperate?.(false);
        setIsCheckInsideMapOperate?.(true);
        setStatus(true);
        setRulerType(type); // 设置测距类型
        setSelected((state) => state + 1); // 高亮工具箱按钮
        setIsShowPanel(true); // 打开快捷面板
        clearClickEvent && clearClickEvent(); // 清除地图点击事件
        rulerIns?.turnOn(); // 开启距离量测功能
        setTargetOperation && setTargetOperation('ruler'); // 记录当前操作类型
      }
    },

    // 处理特殊场景：高德的RangingTool工具类，在确定了起点后(只有一个起点时)，当点击右键时会自动清空地图测距的覆盖物，所以这里需要处理相关的数据恢复初始值
    handleSpecialRightClick() {
      // 判断是否只有一个起点
      if (nodePositionsRef.current && nodePositionsRef.current?.length === 1) {
        nodePositionsRef.current = [];
        setTotalDistance(0);
        // 更新距离显示Marker
        methods.handleMouseMove({});
      }
    },


    /**
     * @description 调取高德接口获取测距数据
     * @param start 起点经纬度（地址）
     * @param end 终点经纬度（地址）
     * @param mode 测距类型
     * @param Constructor //实例
     * @return 返回测距信息 { mode, distance, time }
     */
    calculateDistance: (start, end, mode, Constructor, record) => {
      return new Promise((resolve, reject) => {
        const instance = new Constructor({
          map: _mapIns,
          autoFitView: isAutoFitView
        });
        instance.search(start, end, function (status, result) {
          if (status === 'complete') {
            const distance = result.routes[0].distance || 0;
            const time = result.routes[0].time || 0;
            const info = { mode, distance, time, instance };
            resolve(info);
          } else {
            record && rulerIns._removeRecord(record);
            // 「步行距离过远」是高德 Walking 接口的常见专属语义，保留原文案
            if (mode === '步行') {
              V2Message.error('您测量的步行距离太远啦');
            } else {
              // V2Message.error(`获取${mode}数据失败。`);
              // 统一文案
              V2Message.error('路线规划失败，请稍后重试');
            }
            reject(`获取${mode}数据失败：` + result);
          }
        });
      });
    },

    /**
     * @description 绘制结束距离信息
     * @param start 起点经纬度（必须是经纬度信息，因为获取地址采用的是经纬度为参数）
     * @param end 终点经纬度
     * @param record 本条测距记录
     * @param overrideRulerType 可选；输入模式下由外部指定测距类型（绕过外层 rulerType state）
     * @param onCloseClick 可选；输入模式下 closeIcon 单删后的额外回调（用于同步移除 ref 引用）
     * @param liftCard 可选；是否让 endMarker / closeIcon 整体向上靠近终点（仅输入模式启用，与终点更紧凑）
     * @return 返回 group（含 endMarker 与 closeIcon），失败时 return undefined
     */
    drawEndMarker: async (start, end, record, overrideRulerType?: number, onCloseClick?: () => void, liftCard?: boolean) => {
      if (!start && !end) return;
      // 实际生效的测距类型：优先外部传入（输入模式），否则取外层 state
      const effectiveType = overrideRulerType ?? rulerType;

      const startAddress = String(await getLngLatAddress(start)) || '-';
      const endAddress = String(await getLngLatAddress(end)) || '-';

      let measureInfo:RulerInfoType = {
        startAddress,
        endAddress,
        mode: rulers[effectiveType - 1].name,
        time: 0,
        distance: 0,
      };
      let info:any = {};
      switch (effectiveType) {
        case RulerType.Line: // 直线
          const distance = window.AMap.GeometryUtil.distance(start, end);
          info = { startAddress, endAddress, mode: '直线', distance };
          break;
        case RulerType.Walk: // 步行
          if (!window?.AMap?.Walking) {
            throw new Error('AMap.Walking 未引入！');
          }
          info = await (calculateDistance(start, end, '步行', window.AMap.Walking, record) as any).catch(() => {
            // 不catch浏览器会显示异常，比如测距远距离步行时
          });
          if (!info) return; // 异常时结束处理，不再展示marker
          break;
        case RulerType.Drive: // 驾车
          if (!window?.AMap?.Driving) {
            throw new Error('AMap.Driving 未引入！');
          }
          info = await (calculateDistance(start, end, '驾车', window.AMap.Driving, record) as any).catch(() => {
            // 不catch浏览器会显示异常
          });
          if (!info) return; // 异常时结束处理，不再展示marker
          break;
        case RulerType.Ride: // 骑行
          if (!window?.AMap?.Riding) {
            throw new Error('AMap.Riding 未引入！');
          }
          info = await (calculateDistance(start, end, '骑行', window.AMap.Riding, record) as any).catch(() => {
            // 不catch浏览器会显示异常
          });
          if (!info) return; // 异常时结束处理，不再展示marker
          break;
        default:
          break;
      }

      measureInfo = {
        ...measureInfo,
        ...info
      };

      if (isNotEmptyAny(measureInfo)) {
        // liftCard=true 时（输入模式）卡片整体上移，与终点更紧凑；两个 offset 保持 10px 联动差，避免关闭按钮错位
        const endMarkerOffsetY = liftCard ? 8 : 30;
        const closeIconOffsetY = liftCard ? 18 : 40;
        const group :any = [];
        const endMarker = new window.AMap.Marker({
          map: _mapIns,
          zIndex: zIndex,
          anchor: 'top-left',
          icon: ' ',
          offset: new window.AMap.Pixel(-6, endMarkerOffsetY),
          draggable: true,
        });
        /**
         * 参照以下文件实现，如此处有问题可前往该文件查看并对比，来解决问题
         * src/views/youth/pages/map/components/TopContent/Tools/DrawPoint/DrawPointTool/index.tsx
         */
        endMarker.on('dragstart', (e) => {
          dragPixelRef.current = new window.AMap.Pixel(e.target._points[0] - e.pixel.x, e.target._points[1] - e.pixel.y);
          endMarker.setOffset(dragPixelRef.current);
        });
        endMarker.on('dragging', (e) => {
          const markerLeftTop = [dragPixelRef.current.x + e.pixel.x, dragPixelRef.current.y + e.pixel.y];
          // 转换为经纬度坐标
          const lnglat = _mapIns.containerToLngLat(new window.AMap.Pixel(markerLeftTop[0], markerLeftTop[1]));

          closeIcon.setOffset(new window.AMap.Pixel(214, 9));
          closeIcon.setPosition(lnglat);
        });
        endMarker.on('dragend', (e) => {
          const markerLeftTop = [dragPixelRef.current.x + e.pixel.x, dragPixelRef.current.y + e.pixel.y];
          // 转换为经纬度坐标
          const lnglat = _mapIns.containerToLngLat(new window.AMap.Pixel(markerLeftTop[0], markerLeftTop[1]));

          endMarker.setOffset(new window.AMap.Pixel(0, 0));
          endMarker.setPosition(lnglat);
          closeIcon.setOffset(new window.AMap.Pixel(214, 9));
          closeIcon.setPosition(lnglat);
        });

        const closeIcon = new window.AMap.Marker({
          map: _mapIns,
          anchor: 'top-left',
          zIndex: zIndex,
          content: `<svg style='width: 8px; height: 8px;' aria-hidden><use xlink:href='#iconic_close_colour_seven' style='fill:#132144 '/>
          </svg>`,
          offset: new window.AMap.Pixel(214, closeIconOffsetY)
        });

        const t = measureInfo.time || 0;
        const dis = measureInfo.distance || 0;
        const time = t > 3600 ? (t / 3600).toFixed(1) : (t / 60).toFixed(0);
        const distance = dis >= 1000 ? (dis / 1000).toFixed(2) : dis.toFixed(0);


        // amapRuler 通过 src/common/styles/amap.less 引入样式
        // 直线类型没有路径规划，约耗时恒为 0 无意义，故隐藏「约耗时」一行
        const con = `<div class='amapRuler'>
        <div class='disTitle'>${measureInfo.mode || '-'}距离</div>
        <div class="tipsItems" >
          <div class='itemDis'><span class="count">${distance}<span class="unit">${dis >= 1000 ? 'km' : 'm'}</span></span><span class="des">距离</span>
          </div>
          ${effectiveType === RulerType.Line ? '' : `<div class="itemTime"><span class="count">${time || '-'}<span class="unit">${t > 3600 ? 'h' : 'min'}</span></span><span class="des">约耗时</span>
          </div>`}
        </div>
        <div class="address">
          <div class="addressItem"><div class="tipsLabel">起点：</div><span class='tipsValue'>${measureInfo.startAddress || '-'}</span></div>
          <div class="addressItem"><div class="tipsLabel">终点：</div><span class='tipsValue'>${measureInfo.endAddress || '-'}</span></div>
        </div>
      </div>`;

        endMarker.setPosition(end);
        endMarker.setContent(con);
        closeIcon.setPosition(end);// 设置覆盖物的位置信息

        group.push(endMarker);
        group.push(closeIcon);

        setRulerInfoMarkers(group);

        closeIcon.on('click', () => {
          _mapIns.remove(group);
          record && rulerIns?._removeRecord(record);

          info?.instance && info?.instance.clear();
          // 输入模式下同步从 inputModeMarkersRef 移除该条 entry，避免悬挂引用
          onCloseClick?.();
        });

        _mapIns.add(group);

        // 把路径规划实例挂到 group 上（非破坏式扩展），供输入模式记录用于 .clear()
        // 现有调用方未读 return 值，加属性不影响兼容
        (group as any).__instance = info?.instance;
        return group;
      }
    },
    handleMouseMove(e) {
      const lngLat = e.lnglat; // 鼠标位置信息
      let dis = 0;
      // 直线
      const tempPosi = nodePositionsRef.current.slice(-1)[0];
      if (!tempPosi) {
        tipMarkerREf.current?.setContent(` `);
        return;
      };
      const tempDis = window.AMap.GeometryUtil.distance(tempPosi, lngLat); // 直线

      totalDistanceRef.current = totalDistance;
      dis = totalDistanceRef.current + tempDis;
      const content = `
      <div style="width: 176px; height: 51px; background: #fff; padding: 6px;border-radius: 2px;
      border: 1px solid #333333;">
      <span style="font-size: 14px;font-weight: bolder;color: #333;">
      当前距离 <span style="color: #F23030;"> ${(dis / 1000).toFixed(2)}</span> 公里</span></br>
      <span style="font-size: 12px;">单击继续，双击或右键结束</span> </div>`;

      tipMarkerREf.current?.setPosition(lngLat); // 设置覆盖物的位置信息
      tipMarkerREf.current?.setContent(content); // 更新距离
    },
    // 监听测距过程中添加的节点信息;
    handleAddNode({ position }) {
      // 将当前节点位置添加到节点位置数组中
      setRulering(true);

      nodePositionsRef.current = [...nodePositionsRef.current, position];
      const length = nodePositionsRef.current.length;
      // 直线
      if (length >= 2 && rulerType === RulerType.Line) {
        // 当节点数大于等于2时，计算两点之间的距离，并累加到总距离上
        const lastNode = nodePositionsRef.current[length - 2];
        const distance = window.AMap.GeometryUtil.distance(lastNode, position);
        const newTotalDistance = totalDistanceRef.current + distance;

        setTotalDistance(newTotalDistance); // 更新总距离
        totalDistanceRef.current = newTotalDistance;
      }

      // 非直线
      if (length >= 2 && rulerType !== RulerType.Line) {
        rulerIns.turnOff();
        methods.handleEnd();
      }
    },

    // 监听测距结束
    handleEnd() {
      if (rulerEventId) {
        // bigdataBtn(rulerEventId, '', '工具箱-测距', '点击工具箱-测距');
        bigdataFnRef.current && bigdataFnRef.current(rulerEventId, '工具箱-测距', '点击了工具箱测距', { op_block: '工具箱', op_event: ``, });
      }
      const end = nodePositionsRef.current.slice(-1)[0];
      if (rulerType !== RulerType.Line) {
        const record = rulerIns._lastRecord;
        drawEndMarker(nodePositionsRef.current[0], end, record);
      }
      setTotalDistance(0);
      setRulerType(0);
      setRulering(false);
      rulerIns.turnOff();
      nodePositionsRef.current = [];
      totalDistanceRef.current = 0;
      addClickEvent && addClickEvent(); // 恢复地图点击事件
    },

    /**
     * 清空「输入」模式下产生的所有覆盖物（含 Polyline、起/终点 marker、endMarker 卡片、closeIcon、路径实例）
     * 不影响用户在打开输入弹框之前通过地图点击产生的现有测距
     */
    clearInputModeMarkers() {
      inputModeMarkersRef.current.forEach((entry: any) => {
        (entry.overlays || []).forEach((o: any) => {
          try { _mapIns?.remove?.(o); } catch (e) { /* 已被 closeIcon 单删时忽略 */ }
        });
        try { entry.instance?.clear?.(); } catch (e) { /* noop */ }
      });
      inputModeMarkersRef.current = [];
    },

    /**
     * 处理来自 RulerInputPanel 的测距请求
     * - 直线（rulerType=1）：补画 Polyline + 起/终点 marker（因没有 RangingTool 自动连线）
     * - 步行/驾车/骑行：依赖 AMap.Walking/Driving/Riding 实例自渲染路径
     * - 所有产生的覆盖物 push 到 inputModeMarkersRef.current 当前 entry，关闭弹框时统一清空
     */
    async handleInputMeasure({ start, end, rulerType: inputType }: {
      start: [number, number];
      end: [number, number];
      startAddress: string;
      endAddress: string;
      rulerType: number;
    }) {
      if (!_mapIns) return;
      // 每次新的测距请求前，先清掉之前的输入模式测距覆盖物（避免类型切换/POI 变更时旧绘制残留）
      methods.clearInputModeMarkers();
      // 创建本次绘制的 entry（先入 ref，后填 overlays / instance；失败时移除）
      const entry: { overlays: any[]; instance?: any } = { overlays: [] };
      inputModeMarkersRef.current.push(entry);

      // 直线模式：自画连线 + 起/终点 marker（视觉对齐 RangingTool）
      if (inputType === RulerType.Line) {
        const startMarker = new window.AMap.Marker({
          icon: new window.AMap.Icon({
            image: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/ic_amap_route_start.png`,
            size: new window.AMap.Size(25, 30),
            imageSize: new window.AMap.Size(25, 30),
          }),
          anchor: 'bottom-center',
          zIndex,
          position: start,
        });
        const endPointMarker = new window.AMap.Marker({
          icon: new window.AMap.Icon({
            image: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/ic_amap_route_end.png`,
            size: new window.AMap.Size(25, 30),
            imageSize: new window.AMap.Size(25, 30),
          }),
          anchor: 'bottom-center',
          zIndex,
          position: end,
        });
        const line = new window.AMap.Polyline({
          path: [start, end],
          strokeColor: '#F23030',
          strokeOpacity: 1,
          strokeWeight: 3,
          zIndex,
        });
        _mapIns.add([startMarker, endPointMarker, line]);
        entry.overlays.push(startMarker, endPointMarker, line);
      }

      // 复用 drawEndMarker：record 传 undefined，类型用入参，closeIcon 关闭时同步 splice entry
      // 末尾 true：输入模式下让 endMarker / closeIcon 整体上移（与终点更紧凑）
      const group = await drawEndMarker(start, end, undefined, inputType, () => {
        // closeIcon 单删兜底：清理 entry.overlays 全部成员（含 Line 模式手画的 Polyline + 起终点 marker）
        // group 内成员已被 closeIcon.click 自身的 _mapIns.remove(group) 清过，try/catch 兜底重复 remove 幂等
        entry.overlays.forEach((o: any) => {
          try { _mapIns?.remove?.(o); } catch (e) { /* noop */ }
        });
        const idx = inputModeMarkersRef.current.indexOf(entry);
        if (idx >= 0) inputModeMarkersRef.current.splice(idx, 1);
      }, true);

      // 异步竞态防护：drawEndMarker 等待期间，本 entry 可能已被新一次 handleInputMeasure 触发的
      // clearInputModeMarkers 移除（用户连续切换类型/POI）。此时 group 内 endMarker / closeIcon 已被
      // _mapIns.add 加到地图但不再被 ref 追踪，后续 clearInputModeMarkers 也清不到——立即原地清掉
      // 避免悬挂资源
      if (inputModeMarkersRef.current.indexOf(entry) < 0) {
        if (group) {
          group.forEach((o: any) => {
            try { _mapIns?.remove?.(o); } catch (e) { /* noop */ }
          });
          try { (group as any).__instance?.clear?.(); } catch (e) { /* noop */ }
        }
        return;
      }

      if (!group) {
        // 路径规划失败：drawEndMarker 已弹 Toast，本 entry 已 push 进 ref 的内容也要清掉
        // 直线模式下 entry.overlays 已有起/终点 marker + Polyline，需移除
        entry.overlays.forEach((o: any) => {
          try { _mapIns?.remove?.(o); } catch (e) { /* noop */ }
        });
        const idx = inputModeMarkersRef.current.indexOf(entry);
        if (idx >= 0) inputModeMarkersRef.current.splice(idx, 1);
        return;
      }
      // 成功：把 endMarker + closeIcon 也并入 entry.overlays，并记录路径规划实例
      entry.overlays.push(...group);
      entry.instance = (group as any).__instance;

      // 末尾 fitView：自动调整地图视野让起点、终点、线段/路径、卡片都尽量在屏幕内
      // setFitView 只看 marker.position 不感知 offset；卡片视觉占位由 padding 抵消（右 360 避输入面板、下 220 避卡片）
      // 步行/驾车/骑行下 Walking/Driving/Riding 实例自绘的起终点/路径不在 entry.overlays 里，
      // 故用 start/end 透明 marker 兜底，保证两端都入视野
      const fitAnchors = [
        new window.AMap.Marker({ position: start, opacity: 0, map: _mapIns }),
        new window.AMap.Marker({ position: end, opacity: 0, map: _mapIns }),
      ];
      try {
        _mapIns?.setFitView?.(
          [...entry.overlays, ...fitAnchors],
          true, // 不带动画过渡
          [260, 360, 220, 80], // 上 / 右 / 下 / 左
        );
      } catch (e) { /* noop */ }
      fitAnchors.forEach((m) => {
        try { _mapIns?.remove?.(m); } catch (e) { /* noop */ }
      });
    },

    /**
     * 关闭「输入」弹框统一处理：清覆盖物 + 重置工具箱状态
     * ShortCutPanel 的重新显示由外层 ToolBox 在 onClose 回调里负责
     */
    handleCloseInputPanel() {
      methods.clearInputModeMarkers();
      setIsShowInputPanel(false);
      setStatus(false);
      setSelected((state) => (state === 0 ? 0 : state - 1));
      setRulerType(0);
      finallyShowStatus?.(false);
      setIsCheckInsideMapOperate?.(false);
      setTargetOperation && setTargetOperation('');
    },

    /* 渲染测距各类型选择 */
    renderMoreRuler() {
      return (
        <div className={styles.moreRulerCon} >
          {rulers.map((item) => (
            <div
              key={item.type}
              className={cs(styles.moreRulerItem, 'bg-fff pointer selectNone', rulerType === item.type ? 'c-006' : 'c-222')}
              onClick={() => onClickRuler(item.type)} // 变更测距类型
            >
              <div className={styles.itemIcon}>
                <IconFont iconHref={item.icon} />
              </div>
              <span className={styles.itemName}>{item.name}</span>
            </div>
          ))}
        </div>
      );
    }
  });

  // 暴露相关方法
  useImperativeHandle(ref, () => ({
    handleClickRuler: (type: number) => onClickRuler(type), // 外部操作测距
    clear,
    // 输入模式专用方法（供 ToolBox 在收到 RulerInputPanel 回调时调用）
    handleInputMeasure: methods.handleInputMeasure,
    handleCloseInputPanel: methods.handleCloseInputPanel,
  }));


  return (
    <div className={styles.rulerTool}>
      <div
        className={cs(styles.satellite, className, 'bg-fff pointer selectNone', status && styles.satelliteSelected)}
        onClick={() => onClickRuler(RulerType.Line)}
        style={style}
      >
        <div className={cs(styles.satelliteCon, status && styles.satelliteConSelected)}>
          <IconFont iconHref='iconic_ceju' style={{ width: '16px', height: '16px' }} />
          <span className='inline-block ml-5 c-222'>测距</span>
        </div>
      </div>
      {
        trigger === 'hover' ? (
          <div className={cs(styles.moreRulerConWrapper, floatDirection === 'left' && styles.moreRulerConWrapperLeft)}>
            <div className={styles.moreRuler}>
              {/* 测距hover */}
              {methods.renderMoreRuler()}
            </div>
            <div className={styles.box}></div>
          </div>
        ) : (
          <div className={cs(styles.moreRuler, floatDirection === 'left' && styles.moreRulerConWrapperLeftWithClick)}
            // style={{
            //   // 原本left为112px
            //   left: +style?.width || 112
            // }}
          >
            {/* 测距hover */}
            {methods.renderMoreRuler()}
          </div>
        )
      }
    </div>
  );
});

export default memo(Ruler);
